// src/pages/admin/AdminSlotPage.jsx
import React from "react";
import AdminSlotList from "../../components/AdminSlotList";

export default function AdminSlotPage() {
  return <AdminSlotList />;
}
